var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"overlay-backdrop",class:{ visible: _vm.visible },on:{"click":_vm.hide}}),_c('notifications-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }